<template>
	<div class="FinishSetUp">
		<!-- <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    > -->
		<div class="s1">
			<div class="s1__content">
				<!-- <AccountSettingNavBar /> -->
				<h2>Review Your Information</h2>
				<div class="s1__content--review">
					<el-row
						v-for="(item, key, index) in userRegisterDetails"
						v-if="
							key != 'sales_analytics_and_forcasting' &&
								key != 'expiry_management' &&
								key != 'inventory_management' &&
								key != 'workforce_planning' &&
								key != 'all' &&
								key != 'is_single_location' &&
								key != 'other_company_sector' &&
								key != 'selected_sector' &&
								key != 'start_date1' &&
								key != 'outletData' &&
								key != 'loginUserDetails'
						"
						:key="index"
					>
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<div class="s1__content--label">
								<p>
									{{ key.replace(/_/g, " ") }}
								</p>
							</div>
						</el-col>
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<div class="s1__content--value break-words">
								<p>{{ item }}</p>
							</div>
						</el-col>
					</el-row>
					<el-row v-if="userRegisterDetails.selected_sector != 'Other'">
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<div class="s1__content--label">
								<p>
									Selected Sector
								</p>
							</div>
						</el-col>
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<div class="s1__content--value">
								<p>{{ userRegisterDetails.selected_sector }}</p>
							</div>
						</el-col>
					</el-row>
					<el-row v-if="userRegisterDetails.other_company_sector">
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<div class="s1__content--label">
								<p>
									Other Sector
								</p>
							</div>
						</el-col>
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<div class="s1__content--value">
								<p>{{ userRegisterDetails.other_company_sector }}</p>
							</div>
						</el-col>
					</el-row>
					<el-row v-if="userRegisterDetails.is_single_location == false">
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<div class="s1__content--label">
								<p>
									Is More Than One Store
								</p>
							</div>
						</el-col>
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<div
								v-if="userRegisterDetails.is_single_location == true"
								class="s1__content--value"
							>
								{{ userRegisterDetails.is_single_location }}
								<p>Yes</p>
							</div>
							<div v-else class="s1__content--value">
								<p>No</p>
							</div>
						</el-col>
					</el-row>
					<el-row v-if="userRegisterDetails.is_single_location == true">
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<div class="s1__content--label">
								<p>
									Number of Stores
								</p>
							</div>
						</el-col>
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<div class="s1__content--value">
								<p>{{ userRegisterDetails.more_store }}</p>
							</div>
						</el-col>
					</el-row>
					<el-row
						v-if="
							userRegisterDetails.sales_analytics_and_forcasting == true ||
								userRegisterDetails.expiry_management == true ||
								userRegisterDetails.inventory_management == true ||
								userRegisterDetails.workforce_planning == true ||
								userRegisterDetails.all == true
						"
					>
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<div class="s1__content--label">
								<p>
									Account Type
								</p>
							</div>
						</el-col>
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<div class="s1__content--value">
								<div v-if="userRegisterDetails.all == true">
									<p
										v-if="
											(userRegisterDetails.all == true &&
												userRegisterDetails.inventory_management == true) ||
												userRegisterDetails.expiry_management == true ||
												userRegisterDetails.workforce_planning == true ||
												userRegisterDetails.sales_analytics_and_forcasting ==
													true
										"
									>
										Sales analytics and forecasting <br />
										Expiry management<br />
										Inventory management<br />
										Workforce Planning,
									</p>
								</div>
								<div v-else>
									<p
										v-if="
											userRegisterDetails.sales_analytics_and_forcasting == true
										"
									>
										Sales analytics and forcasting
									</p>
									<p v-if="userRegisterDetails.expiry_management == true">
										Expiry management
									</p>
									<p v-if="userRegisterDetails.inventory_management == true">
										Inventory management
									</p>
									<p v-if="userRegisterDetails.workforce_planning == true">
										Workforce Planning
									</p>
									<!-- <p v-if="userRegisterDetails.all == true">
                      Sales analytics and forcasting <br>
                      Expiry management<br>
                      Inventory management
                    </p> -->
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="privacy-main">
				<div class="px-2">
					<a href="" class="text-base mr-4">
						Privacy Policy
					</a>
				</div>
				<div class="text-base ">
					<input
						v-validate="'required'"
						type="checkbox"
						name="privacy_policy"
					/>
					I agree to the terms of service
				</div>
			</div>
			<span v-show="errors.has('privacy_policy')" class="text-red-dark text-xs">
				Please accept privacy policy.
			</span>
		</div>

		<div class="FinishSetUp__btn_section">
			<button class="mr-2" @click="goToAccountType()">
				Previous
			</button>
			<button @click="submitUserRegData()">
				Sign Up
			</button>
		</div>
		<!-- </el-dialog> -->
	</div>
</template>

<script>
import { serverAddr } from "../../networkConfig";
import { FinishSetUpNC } from "../../../mixins/FinishSetUpNC";
export default {
	name: "FinishSetUp",
	mixins: [FinishSetUpNC],
	props: [],
	data() {
		return {
			dialogVisible: true
		};
	},
	computed: {
		userRegisterDetails() {
			return this.$store.state.userRegistration;
		}
	},
	created() {
		console.log("this.userRegisterDetails", this.userRegisterDetails);
	},
	methods: {
		goToAccountType() {
			this.$store.commit("showAccountType", true);
			this.$store.commit("showUserInformation", false);
			this.$store.commit("showFinishSetup", false);
		},
		submitUserRegData() {
			this.$validator.validateAll().then(result => {
				if (result) {
					serverAddr
						.post("/company/register/", {
							company: {
								name: this.$store.state.userRegistration.company_name,
								membership: "trial",
								country: this.$store.state.userRegistration.selected_country,
								city: this.$store.state.userRegistration.selected_city,
								address:
									this.$store.state.userRegistration.Address1 +
									" " +
									this.$store.state.userRegistration.Address2,
								zip_code: this.$store.state.userRegistration.zip_code,
								financial_start: this.$store.state.userRegistration.start_date,
								financial_end: this.$store.state.userRegistration.start_end,
								is_single_location: this.$store.state.userRegistration
									.is_single_location,
								selected_sector: this.$store.state.userRegistration
									.selected_sector,
								other_company_sector: this.$store.state.userRegistration
									.other_company_sector,
								more_store: this.$store.state.userRegistration.more_store
							},
							user: {
								email: this.$store.state.userRegistration.email,
								full_name: this.$store.state.userRegistration.full_name,
							}
						})
						.then(this.postFinishSetUpNC)
						.catch(error => {
							let validationKey = "";
							let validationMessage = "";
							let a = JSON.parse(error.response.data).user;
							for (var key in a) {
								validationKey = key;
								validationMessage = a[key];
							}
							let msg = validationMessage.join().replace("This", validationKey);

							this.$notify.error({
								title: "Error",
								message: msg,
								// message: `<ul>${JSON.parse(error.response.data)
								// 	.map(
								// 		item =>
								// 			`<li>${Object.keys(item).map(key => item[key])}</li>`
								// 	)
								// 	.join("")}</ul>`,
								// message:
								// 	"This email id already exists. Please sign up with a different email id",
								type: "Error"
							});
						});
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./FinishSetUp.scss";
@import "../../assets/css/variable.scss";
</style>
<style>
/*elemet ui notification CSS*/
.el-notification {
	z-index: 9999 !important;
}
.FinishSetUp .el-dialog {
	max-width: 650px;
	width: 680px;
	margin-top: 0 !important;
}
@media screen and (max-width: 700px) {
	.FinishSetUp .el-dialog {
		width: 90%;
	}
}

.FinishSetUp .el-dialog__body {
	padding: 0 0 30px 0;
}
.FinishSetUp .el-dialog__header {
	@apply p-0;
}
.FinishSetUp .FinishSetUp_button {
	text-align: right !important;
}
.FinishSetUp .el-button--primary {
	background-color: #2c9bce;
	padding: 13px 12px 11px;
	border-radius: 2px;
	font-size: 15px;
	cursor: pointer;
	letter-spacing: 0.02em;
	transition: all 0.2s ease;
	color: #fff;
	border: none;
}
.FinishSetUp .el-icon-close {
	display: none;
}
.FinishSetUp .el-notification {
	z-index: 99999;
	position: relative;
}
@media screen and (max-width: 576px) {
	.FinishSetUp .FinishSetUp_button {
		margin-top: 20px;
		text-align: center !important;
	}
}
</style>
